Object.defineProperty(exports,"__esModule",{value:true});exports.default=



pageState;var _pageStateMethod=require('./pageStateMethod');var _pageStateMethod2=_interopRequireDefault(_pageStateMethod);var _withPageStateComponent=require('./withPageStateComponent');var _withPageStateComponent2=_interopRequireDefault(_withPageStateComponent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function pageState(){for(var _len=arguments.length,configs=Array(_len),_key=0;_key<_len;_key++){configs[_key]=arguments[_key];}
return function decorator(){
if(arguments.length===1){

return _withPageStateComponent2.default.apply(undefined,configs).apply(undefined,arguments);
}

return _pageStateMethod2.default.apply(undefined,configs).apply(undefined,arguments);
};
}